import React from 'react'
import { SnopPage } from "@auteco/pages"

const SnopContainer = () => {
    return (
        <SnopPage />
    )
}

export { SnopContainer }